// extracted by mini-css-extract-plugin
module.exports = {"full_width_container":"fullwidthSection_full_width_container__QIwcP"};